import type { Speaker } from "src/types";

export const DEFAULT_SPEAKERS: Speaker[] = [
  {
    id: 1,
    name: "Nayla O'Moore",
    first_name: "Nayla",
    last_name: "O'Moore",
    headline: "CEO, Venchi",
    bio: "Update this speaker or import speakers from the preference panel",
    image_url: "/canvas/nolan/images/headshot-1.e9d6e5c0.jpg",
    social: {
      linkedin_url: "https://linkedin.com",
      twitter_url: "https://twitter.com",
      website_url: "https://website.com",
    },
  },
  {
    id: 2,
    name: "Eduard Bauer",
    first_name: "Eduard",
    last_name: "Bauer",
    headline: "Head of business development, Venchi",
    bio: "Update this speaker or import speakers from the preference panel",
    image_url: "/canvas/nolan/images/headshot-2.69497d25.jpg",
    social: {
      linkedin_url: "https://linkedin.com",
      twitter_url: "https://twitter.com",
      website_url: "https://website.com",
    },
  },
  {
    id: 3,
    name: "Marwah Cherry",
    first_name: "Marwah",
    last_name: "Cherry",
    headline: "CEO, Acme Inc. ",
    bio: "Update this speaker or import speakers from the preference panel",
    image_url: "/canvas/nolan/images/headshot-3.28867434.jpg",
    social: {
      linkedin_url: "https://linkedin.com",
      twitter_url: "https://twitter.com",
      website_url: "https://website.com",
    },
  },
  {
    id: 4,
    name: "Andrea Orlando",
    first_name: "Andrea",
    last_name: "Orlando",
    headline: "Global sustainability manager, Zikakabo",
    bio: "Update this speaker or import speakers from the preference panel",
    image_url: "/canvas/nolan/images/headshot-4.5a225d41.jpg",
    social: {
      linkedin_url: "https://linkedin.com",
      twitter_url: "https://twitter.com",
      website_url: "https://website.com",
    },
  },
  {
    id: 5,
    name: "Aleksandra Walsh",
    first_name: "Aleksandra",
    last_name: "Walsh",
    headline: "Senior Manager, Logistics, ACME Inc.",
    bio: "Update this speaker or import speakers from the preference panel",
    image_url: "/canvas/nolan/images/headshot-5.96c61485.jpg",
    social: {
      linkedin_url: "https://linkedin.com",
      twitter_url: "https://twitter.com",
      website_url: "https://website.com",
    },
  },
  {
    id: 6,
    name: "Isabella Fearghal",
    first_name: "Isabella",
    last_name: "Fearghal",
    headline: "Head of Community, Acme Inc.",
    bio: "Update this speaker or import speakers from the preference panel",
    image_url: "/canvas/nolan/images/headshot-6.4705c6d8.jpg",
    social: {
      linkedin_url: "https://linkedin.com",
      twitter_url: "https://twitter.com",
      website_url: "https://website.com",
    },
  },
];
